module.exports = __webpack_public_path__ + "img/room.89f880b3.png";